var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardInput(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6875 15.6875V13H10.3125V15.6875H31.6875ZM31.6875 29V21H10.3125V29H31.6875ZM31.6875 10.3125C32.4375 10.3125 33.0625 10.5833 33.5625 11.125C34.0625 11.625 34.3125 12.25 34.3125 13V29C34.3125 29.75 34.0625 30.3958 33.5625 30.9375C33.0625 31.4375 32.4375 31.6875 31.6875 31.6875H10.3125C9.5625 31.6875 8.9375 31.4375 8.4375 30.9375C7.9375 30.3958 7.6875 29.75 7.6875 29V13C7.6875 12.25 7.9375 11.625 8.4375 11.125C8.9375 10.5833 9.5625 10.3125 10.3125 10.3125H31.6875Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardInput);
export default __webpack_public_path__ + "static/media/credit_card_Input.7efaa2388c36a14e406a81ebbc53f7e0.svg";
export { ForwardRef as ReactComponent };